<template>
    <PageComponent 
        :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
        :addButtonLabel="addButtonLabel"
        @handleAddNew="addNewContact"
        :searchFilters="searchFilters"
        :dropdownOptions="dropdownOptions"
        @handleDynamicOption="handleDynamicOption"
        @searchPage="searchContacts"
        @resetFilters="resetFilters"
        @removeItem="removeContact"
        @removeSelectedItems="removeContacts"
        :addingRight="addingRight"
        :removingRight="removingRight"
        :rightsModule="rightsModule"
        :columns="tableColumns"
        :rows="contactsList"
        :actions="actions"
        :idField="idField"
        @handleSelectionChange="handleSelectionChange"
        @handleActionClick="handleActionClick"
        :count="depCount"
        :currentPage="currentPage"
        :result="depArrLen"
        @loadPrev="loadPrev"
        @loadNext="loadNext"
        @firstPage="firstPage"
        @lastPage="lastPage"
        :showNextBtn="showNextBtn"
        :showPreviousBtn="showPreviousBtn"
        :selectedValue="selectedValue"
        @selectSearchQuantity="selectSearchQuantity"
    />
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader"  @closeModal="closeModal">
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="saveContact" @handleReset="handleReset"
        />
    </MovableModal>
</template>

<script>
import axios from "axios";
import { ref, computed, watch, onMounted, onBeforeMount } from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default{
    name: 'Lead_Contacts',
    components:{
        PageComponent,MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('');
        const modal_loader = ref('none');
        const title = ref('Contact Details');
        const addButtonLabel = ref('New Contact');
        const addingRight = ref('Adding Lead Contacts');
        const removingRight = ref('Deleting Lead Contacts');
        const rightsModule = ref('CRM');
        const idField = 'crm_contact_id';
        const accountID = ref('');
        const accComponentKey = ref(0);
        const accountArray = computed(() => store.state.Lead_Accounts.accountArr);
        const selectedIds = ref([]);
        const depModalVisible = ref(false);
        const contactsList = ref([]);
        const depResults = ref([]);
        const depArrLen = ref(0);
        const depCount = ref(0);
        const pageCount = ref(0);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const selectedValue = ref(50);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const isEditing = computed(()=> store.state.Lead_Contacts.isEditing)
        const selectedAccount = computed(()=> store.state.Lead_Contacts.selectedAccount);
        const selectedContact = computed(()=> store.state.Lead_Contacts.selectedContact);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Contact Name", key: "name"},
            {label: "Email", key: "email"},
            {label: "Phone No", key: "phone_number"},
            {label: "Designation", key: "designation"},
            {label: "Account", key: "account_name"},
            {label: "Industry", key: "industry"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Contact', rightName: 'Editing Lead Contacts'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Contact', rightName: 'Deleting Lead Contacts'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const customer_name = ref('');
        const email_search = ref('');
        const phone_number_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Search Name...", value: customer_name, width:48},
            {type:'text', placeholder:"Search Phone#...", value: phone_number_search, width:32},
            {type:'text', placeholder:"Search Email...", value: email_search, width:48},
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchLeadAccounts = async() =>{
            await store.dispatch('Lead_Accounts/fetchLeadAccounts', {company:companyID.value})
        };
        const handleSelectedAccount = async(option) =>{
            await store.dispatch('Lead_Accounts/handleSelectedAccount', option)
            accountID.value = store.state.Lead_Accounts.accountID;
            if(selectedAccount.value && selectedContact.value){
                selectedAccount.value.account.crm_contact_id = accountID.value;
            }
        }
        const clearSelectedAccount = async() =>{
            await store.dispatch('Lead_Accounts/updateState', {accountID: ''});
            accountID.value = store.state.Lead_Accounts.accountID;
        }
        const accValue = computed(() => {
           return (selectedContact.value && selectedContact.value.account && !accountID.value) ? selectedContact.value.account.crm_account_id : accountID.value;
        });
        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                { type: 'text', name: 'full_name',label: "Contact Name", value: selectedContact.value?.full_name || '', required: true },
                { type: 'text', name: 'email',label: "Email", value: selectedContact.value?.email || '', required: true },
                { type: 'text', name: 'phone_number',label: "Phone Number", value: selectedContact.value?.phone_number || '', required: true },
                { type: 'text', name: 'designation',label: "Designation", value: selectedContact.value?.designation || '', required: true },
                {  
                    type:'search-dropdown', label:"Account", value: accValue.value, componentKey: accComponentKey,
                    selectOptions: accountArray, optionSelected: handleSelectedAccount, required: true,
                    searchPlaceholder: 'Select Account...', dropdownWidth: '500px', updateValue: selectedAccount.value,
                    clearSearch: clearSelectedAccount
                },
            ];
        };
        watch([selectedContact,selectedAccount], () => {
            if(selectedContact.value && selectedAccount.value){
                accComponentKey.value += 1;
                updateFormFields();
            }else if(selectedAccount.value){
                updateFormFields();
            }
         }, { immediate: true });
        const addNewContact = async() =>{
            updateFormFields();
            depModalVisible.value = true;
            handleReset();
            await store.dispatch("Lead_Contacts/updateState",{isEditing:false, selectedAccount: null, selectedContact: null})
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const contactID = row[idField];
                let formData = {
                    company: companyID.value,
                    crm_contact: contactID
                }
                await store.dispatch('Lead_Contacts/fetchLeadContact',formData).
                then(()=>{
                    depModalVisible.value = true;
                    flex_basis.value = '1/2';
                    flex_basis_percentage.value = '50';
                })
                
            }else if(action == 'delete'){
                const contactID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    crm_contact: contactID
                }
                await store.dispatch('Lead_Contacts/deleteLeadContact',formData).
                then(()=>{
                    searchContacts();
                })
            }
        } 
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            accountID.value = '';
            accComponentKey.value += 1;

        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createLeadContact = async() =>{
            showModalLoader();
            let formData = {
                full_name: formFields.value[0].value,
                email: formFields.value[1].value,
                phone_number: formFields.value[2].value,
                designation: formFields.value[3].value,
                account: accountID.value,
                account_id: accountID.value,
                company: companyID.value
            }
            errors.value = [];
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != 'search-dropdown'){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Lead_Contacts/createLeadContact', formData);
                    if(response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Contact created successfully!');
                        handleReset();
                    }else {
                        toast.error('An error occurred while creating the Contact.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Contact: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchContacts();
                }
            }

        }
        const updateLeadContact = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                full_name: formFields.value[0].value,
                email: formFields.value[1].value,
                phone_number: formFields.value[2].value,
                designation: formFields.value[3].value,
                account: accValue.value,
                account_id: accValue.value,
                company: companyID.value,
                crm_contact: selectedContact.value.crm_contact_id
            }
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != 'search-dropdown'){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                    toast.error('Fill In Required Fields');
            }else{
                try {
                    const response = await store.dispatch('Lead_Contacts/updateLeadContact', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        toast.success("Contact updated successfully!");
                        handleReset();
                    } else {
                        toast.error('An error occurred while updating the Contact.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Contact: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchContacts();
                }
            }
        }
        const saveContact = () =>{
            if(isEditing.value == true){
                updateLeadContact();
            }else{
                createLeadContact();
            }
        }
        const removeContact = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    crm_contact: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Lead_Contacts/deleteLeadContact',formData)
                    if(response && response.status == 200){
                        toast.success("Contact Removed Succesfully");
                        searchContacts();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Contact: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Contact") 
            }else{
                toast.error("Please Select A Contact To Remove")
            }
        }
        const removeContacts = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    crm_contact: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Lead_Contacts/deleteLeadContact',formData)
                    if(response && response.status == 200){
                        toast.success("Contact(s) Removed Succesfully");
                        searchContacts();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Contact(s): ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select A Contact To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchContacts = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: customer_name.value,
                phone_number: phone_number_search.value,
                email: email_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios
            .post(`api/v1/lead-contacts-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                contactsList.value = response.data.results;
                store.commit('Lead_Contacts/LIST_CONTACTS', contactsList.value)
                depResults.value = response.data;
                depArrLen.value = contactsList.value.length;
                depCount.value = depResults.value.count;
                pageCount.value = Math.ceil(depCount.value / selectedValue.value);
                
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchContacts();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchContacts();
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchContacts();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchContacts();
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchContacts(selectedValue.value);
        };
        const dropdownOptions = ref([
            
        ]);
        const handleDynamicOption = async(option) =>{
        
        };
        const resetFilters = () =>{
            email_search.value = '';
            phone_number_search.value = '';
            customer_name.value = '';
            currentPage.value = 1;
            searchContacts();
        };
        const closeModal = async() =>{
            depModalVisible.value = false;
            handleReset();
        }
        onMounted(()=>{
            searchContacts();
            fetchLeadAccounts();
        })
        return{
            title,idField, searchContacts, addButtonLabel, searchFilters, resetFilters, tableColumns, contactsList,handleSelectionChange,
            currentPage,depResults, depArrLen, depCount, pageCount, showNextBtn, showPreviousBtn,modal_top, modal_left, modal_width,
            loadPrev, loadNext, firstPage, lastPage, actions, formFields, depModalVisible, addNewContact,
            displayButtons,flex_basis,flex_basis_percentage, handleActionClick, handleReset, saveContact,
            showLoader, loader, hideLoader, modal_loader, showModalLoader, hideModalLoader, removeContact, removeContacts,
            addingRight,removingRight,rightsModule, closeModal,selectedValue, selectSearchQuantity,dropdownOptions, handleDynamicOption
        }
    }
}
</script>